import { z } from "zod/v4";
import {
  chartExportFormatsSchema,
  vizAxisPresetSchema,
  vizBarLayoutSchema,
  vizPaletteModeSchema,
  vizReferenceLineSchema,
  vizTooltipModeSchema,
  vizXAxisTicksSchema,
} from "@/lib/ai/visualization/views/shared/schema-primitives";
import {
  VIZ_SORT_OPTIONS,
  vizSortSchema,
} from "@/lib/ai/visualization/views/shared/view-options";

/**
 * `bar-ranking` の authoring contract。
 *
 * @remarks
 * ranking chart の user-facing label は LLM が責務を持つため、
 * category/value label を compile 前に必須化する。
 */
export const barRankingAuthoringSchema = z
  .object({
    categoryKey: z.string().min(1),
    categoryLabel: z.string().trim().min(1),
    valueKey: z.string().min(1),
    valueLabel: z.string().trim().min(1),
    sort: z.enum(VIZ_SORT_OPTIONS).optional(),
    limit: z.number().int().min(1).optional(),
  })
  .strict();

/**
 * `BarRanking` runtime component props schema。
 */
export const barRankingComponentSchema = z
  .object({
    dataPath: z.string(),
    categoryKey: z.string(),
    valueKey: z.string(),
    limit: z.number().int().min(1).optional().nullable(),
    layout: vizBarLayoutSchema.optional().nullable(),
    chartHeight: z.number().int().min(280).max(520).optional().nullable(),
    sort: vizSortSchema.optional().nullable(),
    categoryLabel: z.string().optional().nullable(),
    valueLabel: z.string().optional().nullable(),
    axisPreset: vizAxisPresetSchema,
    tooltipMode: vizTooltipModeSchema,
    paletteMode: vizPaletteModeSchema,
    xAxisTicks: vizXAxisTicksSchema,
    referenceLines: z
      .array(vizReferenceLineSchema)
      .max(6)
      .optional()
      .nullable(),
    allowSortControl: z.boolean().optional().nullable(),
    allowExport: z.boolean().optional().nullable(),
    exportFormats: chartExportFormatsSchema,
  })
  .strict();
